import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../pages/auth/auth.service';
import { AuthDataInterface } from '../../pages/auth/auth';

import { USERS_PATHS } from '../../pages/users/users';
import { SECTORS_PATHS } from '../../pages/sectors/sectors';
import { WORK_SHIFT_PATHS } from '../../pages/work-shift/work-shift';
import { NOTIFICATIONS_PATHS } from '../../pages/notifications/notifications';
import { WORK_SHIFTS_PATHS } from '../../pages/work-shifts/work-shifts';
import { COMPANIES_PATHS } from '../../pages/companies/companies';
import { REFERENCES_PATHS } from '../../pages/references/references';
import { APP_SETTINGS_PATHS } from '../../pages/app-settings/app-settings';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-topbar-navigation',
  templateUrl: './topbar-navigation.component.html',
  styleUrls: ['./topbar-navigation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TopbarNavigationComponent implements OnInit {
  public USERS_PATHS = USERS_PATHS;
  public SECTORS_PATHS = SECTORS_PATHS;
  public WORK_SHIFT_PATHS = WORK_SHIFT_PATHS;
  public NOTIFICATIONS_PATHS = NOTIFICATIONS_PATHS;
  public WORK_SHIFTS_PATHS = WORK_SHIFTS_PATHS;
  public COMPANIES_PATHS = COMPANIES_PATHS;
  public REFERENCES_PATHS = REFERENCES_PATHS;
  public APP_SETTINGS_PATHS = APP_SETTINGS_PATHS;
  public authData: AuthDataInterface;

  constructor(public authService: AuthService) {}

  ngOnInit() {
    this.authService.subscribeAuthData().subscribe((authData) => {
      this.authData = authData;
    });
  }

  public toggleWithMenuContext(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }
}
